module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_06-f920e87712fc6f6ecd3dd6901bea0311.png";